import { createRouter, createWebHashHistory } from 'vue-router'
import Index from '@/views/index.vue'
import Home from '@/views/home.vue'
import Detail from '@/views/detail.vue'
import DigitalCommerceServices from '@/views/digitalCommerceServices.vue'
import InternationalTourism from '@/views/internationalTourism.vue'
import CourseMajorDisplay from '@/views/courseMajorDisplay.vue'
import CourseMajorDetail from '@/views/courseMajorDetail.vue'

const routes = [
  {
    path: '/',
    name: '/',
    component: Index
  },
  {
    path: '/Index',
    name: 'Index',
    component: Index
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home
  },
  {
    path: '/Detail',
    name: 'Detail',
    component: Detail
  },
  {
    path: '/DigitalCommerceServices',
    name: 'DigitalCommerceServices',
    component: DigitalCommerceServices
  },
  {
    path: '/InternationalTourism',
    name: 'InternationalTourism',
    component: InternationalTourism
  },
  {
    path: '/CourseMajorDisplay',
    name: 'CourseMajorDisplay',
    component: CourseMajorDisplay,
    meta: { title: '专业管理 - 海职院教学资源平台' },
  },
  {
    path: '/CourseMajorDisplay/detail/:majorId',
    name: 'CourseMajorDetail',
    component: CourseMajorDetail,
    meta: { title: '专业详情 - 海职院教学资源平台' },
  },
]

export default createRouter({
  // history: createWebHashHistory(process.env.BASE_URL),
  history: createWebHashHistory(), // 需要在nginx 那改成 try_files $uri $uri/ /index.html; # vue history 模式 ，需要改成这样
  routes: routes
})


